<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Vorlagenübersicht</h2>
        <TabList class="tab-list" :items="items" :active-item-name="activeItemName"></TabList>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div class="spaces-filter-container">
                    <div class="top-bar-left">
                        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
                        <Checkbox @change="onFilterChanged('Online')" v-model="checked['Online']"
                                  id="filter-in-progress"
                                  title="Online"></Checkbox>
                        <Checkbox @change="onFilterChanged('Desktop')" v-model="checked['Desktop']"
                                  id="filter-in-progress"
                                  title="Desktop"></Checkbox>
                        <Checkbox @change="onFilterChanged('Mobile')" v-model="checked['Mobile']" id="filter-checked"
                                  title="Mobile"></Checkbox>
                        <Checkbox @change="onFilterChanged('Tablet')" v-model="checked['Tablet']" id="filter-built-in"
                                  title="Tablet"></Checkbox>
                    </div>
                    <AdaButton title="NEUE VORLAGE" type="createButton" @click="openCreateInteractionDialog"
                               icon="icon-add"></AdaButton>
                </div>
                <AdaDatatable class="listingTable" :columns="columns" :data="interactionTemplates"
                              :show-pagination="true" :show-search="false" :size-of-page="10"
                              @rowClicked="cellClicked" :search-value="searchValue" :table-filters="[this.tableFilter]"
                              :save-sort-state="true" table-id="tInteractionTable"
                              :transformers="transformers">
                    <AdaButton style="width: 100%; height: 50px" title="NEUE VORLAGE ERSTELLEN" type="fullWidthButton"
                               @click="openCreateInteractionDialog"
                               icon="icon-add"></AdaButton>
                </AdaDatatable>
            </div>
        </transition>
        <Dialog :has-backdrop="true" :show="showCreateInteractionDialog" @close="createInteractionDialogClosed"
                :show-close-button="true">
            <CreateInteractionTemplateDialog></CreateInteractionTemplateDialog>
        </Dialog>
        <Dialog :has-backdrop="true" :show="showEditInteractionDialog" @close="editDialogClose"
                :show-close-button="true" v-if="interactionToEdit">
            <EditInteractionTemplateDialog @saved="interactionEdited()"
                                           :interaction-id="interactionToEdit.id"></EditInteractionTemplateDialog>
        </Dialog>
        <Dialog v-if="interactionToDelete" :show-close-button="true" :show="showDeleteInteractionDialog"
                :has-backdrop="true"
                @close="deleteDialogClose">
            <div class="delete-container">
                <h4>Interaction löschen</h4>
                <div style="margin-bottom: 30px">
                    Soll die Interaction: <span style="font-weight: bold">{{this.interactionToDelete.name}}</span>
                    wirklich
                    gelöscht werden?
                </div>
                <AdaButton :loading="deletingTemplate" class="btn-delete" @click="deleteClicked" title="LÖSCHEN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="interactionToCopy" :show-close-button="true" :show="showCopyInteractionDialog"
                :has-backdrop="true"
                @close="copyDialogClose">
            <div class="delete-container">
                <h4>Interaction kopieren</h4>
                <div style="margin-bottom: 30px">
                    Soll die Interaction: <span style="font-weight: bold">{{this.interactionToCopy.name}}</span>
                    wirklich
                    kopiert werden?
                </div>
                <AdaButton :loading="copyingTemplate" class="btn-delete" @click="copyClicked" title="KOPIEREN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import TabList from "../../../components/tablist/TabList";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import AdaButton from "../../../components/buttons/AdaButton";
    import InputSearch from "../../../components/inputs/InputSearch";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Transformers from "../../../components/tables/Transformers";
    import Dialog from "../../../components/dialog/Dialog";
    import CreateInteractionTemplateDialog from "./CreateInteractionTemplateDialog";
    import EditInteractionTemplateDialog from "./EditInteractionTemplateDialog";
    import Checkbox from "../../../components/inputs/Checkbox";

    const InteractionsRepository = RepositoryFactory.get('interactions');

    export default {
        components: {
            EditInteractionTemplateDialog,
            TabList,
            BreadCrumb,
            AdaDatatable,
            InputSearch,
            AdaButton,
            Dialog,
            CreateInteractionTemplateDialog,
            Checkbox
        },
        data: function () {
            return {
                tableFilter: {
                    propName: 'medium',
                    mode: 'OR',
                    allowedValues: []
                },
                checked: {
                    "Online": false,
                    "Desktop": false,
                    "Mobile": false,
                    "Tablet": false
                },
                interactionToEdit: null,
                showCreateInteractionDialog: false,
                showEditInteractionDialog: false,
                searchValue: '',
                columns: [
                    {
                        viewName: 'Interaktion',
                        propName: 'name',
                        sortable: true,
                        width: '20%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '20%'
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '20%'
                    },
                    {
                        viewName: 'Medium',
                        propName: 'medium',
                        sortable: true,
                        width: '20%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '20%'
                    }
                ],
                rows: [],
                items: [
                    {
                        name: 'Tracking-Listen',
                        link: '/templates/trackinglists'
                    },
                    {
                        name: 'Spaces',
                        link: '/templates/spaces'
                    },
                    {
                        name: 'Module',
                        link: '/templates/modules'
                    },
                    {
                        name: 'Interaktionen',
                        link: '/templates/interactions'
                    }
                ],
                activeItemName: 'Interaktionen',
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span style="cursor: pointer" data-type="edit" class="margin-right hover-highlight icon icon-edit"></span>';
                                        break;
                                    case 'copy':
                                        res += '<span style="cursor: pointer" data-type="duplicate" class="margin-right hover-highlight icon icon-duplicate"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span style="cursor: pointer" data-type="delete" class="margin-right hover-highlight icon icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    },
                    {
                        propName: 'medium',
                        transform: Transformers.interactionMediumTransformer
                    },
                ],
                interactionToDelete: null,
                showDeleteInteractionDialog: false,
                editInteractionDialogClosed: false,
                interactionToCopy: null,
                showCopyInteractionDialog: false,
                loading: true,
                copyingTemplate: false,
                deletingTemplate: false,
                fn: null
            }
        },
        name: "TemplateSpaces",
        mounted() {
            this.fetchInteractionTemplates();
            this.fn = () => {
                this.openCreateInteractionDialog();
            };
            this.$root.$on('createInteractionTemplate', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('createInteractionTemplate', this.fn);
        },
        computed: {
            interactionTemplates() {
                return this.$store.state.interactions.interactionTemplates;
            },
        },
        methods: {
            interactionEdited() {
                this.showEditInteractionDialog = false;
                this.fetchInteractionTemplates();
            },
            onFilterChanged: function (type) {
                this.runFilter(type);
            },
            runFilter: function (type) {
                let allowedValues = [];
                if (type !== 'Online') {
                    this.checked['Online'] = false;
                }
                for (let key in this.checked) {
                    if (this.checked[key]) {
                        allowedValues.push(key);
                    }
                }
                if (this.checked['Online']) {
                    allowedValues = [
                        "Desktop",
                        "Tablet"
                    ];
                    this.checked['Desktop'] = false;
                    this.checked['Mobile'] = false;
                    this.checked['Tablet'] = false;
                    this.tableFilter.mode = 'AND';
                } else {
                    this.tableFilter.mode = 'OR';
                }
                this.tableFilter.allowedValues = allowedValues;
            },
            editDialogClose: function () {
                this.showEditInteractionDialog = false;
                this.interactionToEdit = null;
                this.fetchInteractionTemplates();
            },
            deleteDialogClose: function () {
                this.showDeleteInteractionDialog = false;
                this.interactionToDelete = null;
            },
            copyDialogClose: function () {
                this.showCopyInteractionDialog = false;
                this.interactionToCopy = null;
            },
            openCreateInteractionDialog: function () {
                this.showCreateInteractionDialog = true;
            },
            createInteractionDialogClosed: function () {
                this.showCreateInteractionDialog = false;
                this.fetchInteractionTemplates();
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.interactionToEdit = data.row;
                        this.showEditInteractionDialog = true;
                        break;
                    case 'duplicate':
                        this.showCopyInteractionDialog = true;
                        this.interactionToCopy = data.row;
                        break;
                    case 'delete':
                        this.showDeleteInteractionDialog = true;
                        this.interactionToDelete = data.row;
                        break;
                    default:
                        this.interactionToEdit = data.row;
                        this.showEditInteractionDialog = true;
                        break;
                }
            },
            deleteClicked() {
                this.deletingTemplate = true;
                this.deleteInteractionTemplate(this.interactionToDelete.id);
            },
            copyClicked() {
                this.copyingTemplate = true;
                this.fetchCopyInteraction(this.interactionToCopy.id);
            },
            async fetchInteractionTemplates() {
                await this.$store.dispatch('interactions/fetchInteractionTemplates', true);
                this.loading = false;
            },
            async deleteInteractionTemplate(id) {
                try {
                    await InteractionsRepository.deleteInteraction(id);
                    this.$noty.success("Die Interaction wurde erfolgreich gelöscht.");
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler beim Löschen der Interaction.");
                }
                this.deletingTemplate = false;
                this.showDeleteInteractionDialog = false;
                this.fetchInteractionTemplates();
                this.loading = true;
            },
            async fetchCopyInteraction(id) {
                try {
                    await InteractionsRepository.copyInteraction(id);
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler beim Kopieren der Interaction.");
                }
                this.copyingTemplate = false;
                this.showCopyInteractionDialog = false;
                this.fetchInteractionTemplates();
                this.loading = true;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .spaces-filter-container {
        width: 100%;
        background-color: white;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
    }

    .tab-list {
        margin-bottom: 20px;
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    ::v-deep tbody tr td:nth-child(4) {
        padding: 0 20px;

        span[class*='icon-']:before {
            top: 4px;
            position: relative;
        }
    }

    .btn-delete {
        width: fit-content;
    }

    h4 {
        margin-top: 0;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }
</style>